// Shared line-icon set (Feather-style, stroke = currentColor) so icons stay
// consistent across the app. Size defaults to 18; color is inherited.
import React from 'react';

const base = (size) => ({
  width: size, height: size, viewBox: '0 0 24 24', fill: 'none',
  stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round',
});

export function IcoInsurance({ size = 18 }) {
  return (<svg {...base(size)}><path d="M3 21h18"/><path d="M5 21V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v16"/><path d="M19 21V10l-4-3"/><path d="M8 7h2M8 11h2M8 15h2"/></svg>);
}

export function IcoContacts({ size = 18 }) {
  return (<svg {...base(size)}><path d="M6 3h12a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6z"/><line x1="6" y1="3" x2="6" y2="21"/><circle cx="13" cy="10" r="2.2"/><path d="M9.7 16a3.3 3.3 0 0 1 6.6 0"/></svg>);
}

export function IcoCompare({ size = 18 }) {
  return (<svg {...base(size)}><line x1="6" y1="20" x2="6" y2="12"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="18" y1="20" x2="18" y2="9"/></svg>);
}

export function IcoInvoice({ size = 18 }) {
  return (<svg {...base(size)}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="8" y1="13" x2="16" y2="13"/><line x1="8" y1="17" x2="13" y2="17"/></svg>);
}

export function IcoTasks({ size = 18 }) {
  return (<svg {...base(size)}><polyline points="3 6 4 7 6.5 4.5"/><polyline points="3 12 4 13 6.5 10.5"/><polyline points="3 18 4 19 6.5 16.5"/><line x1="10" y1="6" x2="21" y2="6"/><line x1="10" y1="12" x2="21" y2="12"/><line x1="10" y1="18" x2="21" y2="18"/></svg>);
}

export function IcoCalendar({ size = 18 }) {
  return (<svg {...base(size)}><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>);
}

export function IcoMail({ size = 18 }) {
  return (<svg {...base(size)}><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m2 6 10 7 10-7"/></svg>);
}

export function IcoTow({ size = 14 }) {
  return (<svg {...base(size)}><rect x="1" y="3" width="14" height="12" rx="1"/><path d="M15 8h4l3 3v4h-7z"/><circle cx="5.5" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>);
}

export function IcoRental({ size = 14 }) {
  return (<svg {...base(size)}><path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"/><circle cx="7" cy="17" r="2"/><path d="M9 17h6"/><circle cx="17" cy="17" r="2"/></svg>);
}

export function IcoTag({ size = 13 }) {
  return (<svg {...base(size)}><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>);
}

export function IcoUpload({ size = 18 }) {
  return (<svg {...base(size)}><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>);
}

export function IcoFile({ size = 18 }) {
  return (<svg {...base(size)}><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/><polyline points="13 2 13 9 20 9"/></svg>);
}

export function IcoFolder({ size = 18 }) {
  return (<svg {...base(size)}><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>);
}
